/**
 * Hold quantity_hours i sync med (cost_type, unit, quantity).
 *
 * Interne linjer måles i timer: enheten "d" (dager) ganges med 8, mens "t"
 * eller uspesifisert enhet (null) bruker quantity direkte som timer. Sistnevnte
 * er viktig fordi tilbuds-importen lagrer timer i quantity_hours uten å sette
 * unit="t" — uten null-grenen ble timene nullet ved første redigering av linjen.
 * Kun eksplisitt ikke-tidsbaserte enheter (stk/fast) og eksterne kostnader gir 0t.
 */
export function deriveHours(
  costType: string,
  unit: string | null,
  quantity: number | null,
): number {
  if (costType !== "internal") return 0;
  if (unit === "stk" || unit === "fast") return 0;
  const q = quantity ?? 0;
  return unit === "d" ? q * 8 : q;
}
